export default "__VITE_ASSET__Cz1bre4D__"